import script from "./imgwithFallback.vue?vue&type=script&setup=true&lang=js"
export * from "./imgwithFallback.vue?vue&type=script&setup=true&lang=js"

import "./imgwithFallback.vue?vue&type=style&index=0&id=86fb4174&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86fb4174"]])

export default __exports__